module.exports = __webpack_public_path__ + "img/wa.d266b611.png";